import React from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Carousel from "./components/carousel";
import FeaturedProducts from "./components/FeaturedProducts";
import CategoryAccordion from "./components/CategoryAccordion";
import NewProducts from "./components/NewProducts";
import WhatsAppButton from "./components/WhatsAppButton";

import "./App.css";

function App() {
  return (
    <div className="app-page">

      {/* =====================================================
          NAVEGACIÓN PRINCIPAL
      ===================================================== */}
      <header className="app-header">
        <Navbar />
      </header>

      {/* =====================================================
          CONTENIDO PRINCIPAL
      ===================================================== */}
      <main className="app-main">

        {/* =====================================================
            PORTADA / CARRUSEL
        ===================================================== */}
        <section
          className="app-hero"
          aria-label="Presentación de G&J Frío Industrial"
        >
          <Carousel />
        </section>

        {/* =====================================================
            CONTENIDO CENTRAL
        ===================================================== */}
        <div className="app-content">

          {/* ===================================================
              PRODUCTOS DESTACADOS
          =================================================== */}
          <section
            className="app-section app-section-featured"
            aria-label="Productos destacados"
          >
            <FeaturedProducts />
          </section>

          {/* ===================================================
              CATEGORÍAS
          =================================================== */}
          <section
            className="app-section app-section-categories"
            aria-label="Categorías de productos"
          >
            <CategoryAccordion />
          </section>

          {/* ===================================================
              PRODUCTOS NUEVOS
          =================================================== */}
          <section
            className="app-section app-section-new"
            aria-label="Productos nuevos"
          >
            <NewProducts />
          </section>

        </div>
      </main>

      {/* =====================================================
          PIE DE PÁGINA
      ===================================================== */}
      <Footer />

      {/* =====================================================
          WHATSAPP
      ===================================================== */}
      <WhatsAppButton />

    </div>
  );
}

export default App;